import React, {useState} from "react";
import {connect} from "react-redux";
import {loadPartnerCaps} from "../../../actions/capItemActions";
import {Popover} from "@material-ui/core";

function CapButton(props) {

    const [isOpen, setIsOpen] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () =>  {
        setAnchorEl(null);
        setIsOpen(false);
    };

    const handleClick = (event) => {
        !isOpen && props.loadPartnerCaps();
        setAnchorEl(isOpen ? null : event.currentTarget);
        setIsOpen(!isOpen);
    };

    const getColor = (remainInPercent) => {
        return remainInPercent < 30
            ? "low"
            : remainInPercent < 70
                ? "mid"
                : "many";
    };

    const getCapType = (cap) => {
        if (!cap?.type || cap.type === "INDIVIDUAL") {
            return "";
        }
        return cap.type === "GROUP"
        ? "(Групповая)"
            : cap.type === "PUBLIC"
        ? "(Публичная)"
        :
        "";
    }

    return (
        <>
            <div className="cap" onClick={handleClick} id="capButton">КАПА</div>
            <Popover
                id={id}
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>
                <div className="cap-card">
                    {!props.isCapLoading && props.partnerCaps &&
                    props.partnerCaps.map(capItem =>
                        <div key={capItem.capName + capItem.dailyLimit + capItem.type} className="cap-item">
                            <span className="cap-name">{capItem.capName + getCapType(capItem) + ":" }</span>
                            <span>{(capItem.spentInValue ? capItem.spentInValue : 0)  + (capItem.dailyLimit ? ("/" + capItem.dailyLimit) : "")}</span>
                            { capItem.isServiceCapLimitExhausted
                                ? <span className="cap-percent low">Закончился общий лимит на сервис</span>
                                :
                                <>
                                    <span className={"cap-percent " + getColor((capItem.remainInPercent || 0))}>
                                        {(capItem.remainInPercent || 0) + "%"}
                                    </span>
                                </>
                                }
                        </div>
                    )
                    }
                </div>

            </Popover>
        </>
    )
}
const mapStateToProps = state => ({
    isCapLoading: state.capItemReducer.partnerCapsLoading,
    partnerCaps: state.capItemReducer.partnerCaps,
});

export default connect(mapStateToProps, {loadPartnerCaps})(CapButton);
